import { graphql } from '../graphql';
import { useRequest } from './client/useRequest';
export const SEND_COMMAND = graphql(`
  mutation SendCommand(
    $id: String!
    $command: String!
    $label: String!
    $timestamp: String!
  ) {
    sendCommand(
      input: {
        id: $id
        command: $command
        label: $label
        timestamp: $timestamp
      }
    )
  }
`);
export const useSendCommandRequest = () => {
    return useRequest(SEND_COMMAND, {});
};
